import { Box } from '@chakra-ui/layout';
import { ChakraComponent } from '@chakra-ui/system';

export const Gradient: ChakraComponent<'div'> = ({ children, ...rest }) => (
  <Box bgImg="linear-gradient(to right, #E684AE, #79CBCA, #77A1D3);" {...rest}>
    {children}
  </Box>
);
